module.exports = __webpack_public_path__ + "site/img/logo1.5287caef.png";